<template>
  <Modal v-model="modalValue" title="编辑" width="500" @on-cancel="modalCancel">
    <Row>
      <Col span="20" offset="1">
        <Form ref="addForm" :model="form" :rules="rules" :label-width="100">
          <FormItem label="联系人" prop="contact_name">
            <Input placeholder="请输入联系人" v-model="form.contact_name"></Input>
          </FormItem>
          <FormItem label="联系电话" prop="contact_mobile">
            <Input placeholder="请输入联系电话" v-model="form.contact_mobile"></Input>
          </FormItem>
        </Form>
      </Col>
    </Row>
    <div slot="footer">
      <Button @click="modalCancel">取消</Button>
      <Button :loading="btnLoading" type="primary" @click="modalConfirm">确认</Button>
    </div>
  </Modal>
</template>

<script>
import _ from 'lodash'
import * as apiCompetition from '@/api/activity/competitions'
export default {
  name: 'add-card',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    id: {
      type: [String, Number],
      default: ''
    }
  },
  data () {
    return {
      btnLoading: false,
      form: {
        contact_name: '',
        contact_mobile: ''
      },
      rules: {
        contact_name: [{ required: true, message: '联系人不能为空', trigger: 'blur' }],
        contact_mobile: [{ required: true, message: '联系电话不能为空', trigger: 'blur' }]
      }
    }
  },
  methods: {
    // 获取详情
    getDetail () {},
    // 提交
    modalConfirm () {
      this.$refs['addForm'].validate(valid => {
        if (valid) {
          this.btnLoading = true
          apiCompetition.apiCompetitionsSignEdit(this.id, this.form).then(res => {
            this.$Message.success('编辑成功')
            this.$emit('on-success')
            this.modalCancel()
          }).finally(() => this.btnLoading = false)
        }
      })
    },
    modalCancel () {
      this.$refs['addForm'].resetFields()
      this.$nextTick(() => {
        this.modalValue = false
      })
    }
  },
  computed: {
    modalValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    value (val) {
      if (val && this.isEdit) {
        this.getDetail()
      }
    }
  },
  mounted () {}
}
</script>

<style scoped lang="less"></style>
